export const TickSquare = ({
  strokeColor = "var(--color-green)",
  ...props
}: any) => (
  <svg width={15} height={16} fill="none" {...props}>
    <path
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.625 14.25h3.75c3.125 0 4.375-1.25 4.375-4.375v-3.75C13.75 3 12.5 1.75 9.375 1.75h-3.75C2.5 1.75 1.25 3 1.25 6.125v3.75C1.25 13 2.5 14.25 5.625 14.25Z"
    />
    <path
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4.844 8 1.768 1.768 3.544-3.538"
    />
  </svg>
);
